<template>
  <div class="doctor">
    <div class="first itemWrapper">
      <img src="@/assets/img/user/1.png" alt />
    </div>
    <div class="second itemWrapper">
      <img src="@/assets/img/user/2.png" alt />
    </div>
    <div class="third itemWrapper">
      <img src="@/assets/img/user/3.png" alt />
    </div>
    <div class="fourth itemWrapper">
      <img src="@/assets/img/user/4.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: 'User'
}
</script>

<style lang='stylus' scoped>
@import '~@/assets/styles/varibles.styl'

.doctor
  .itemWrapper
    width 100%
    display flex
    flex-direction row
    justify-content center
    align-items center

    img
      width 1280px

  .first
    background #050206
    height 594px

  .second
    background #E9E4DC
    height 1000px

  .third
    background #F8F8F8
    height 1000px

  .fourth
    background #DCD1D1
    height 1000px
</style>



// WEBPACK FOOTER //
// src/views/User/User.vue